import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { t } from 'i18next';

import { Button } from '../../components/button/Button';
import { Link } from '../../components/link/Link';
import { Tooltip } from '../../components/tooltip/Tooltip';

type TopNavItemProps = {
  href: string;
  icon: any;
  isActive: boolean;
  label: string;
  showLabel?: boolean;
};

export function TopNavItem({ href, icon, isActive, label, showLabel = true }: TopNavItemProps) {
  return isActive ? (
    <div className="top-nav-bar-item">
      <div className="top-nav-bar-button active">
        <FontAwesomeIcon icon={icon} size="lg" />
      </div>
      <div>
        <span className="visuallyHidden">{t('nav.page.selectedPage')}</span>
        {label}
      </div>
    </div>
  ) : (
    <Tooltip content={label} maxResolution={900}>
      <Link href={href} color="gray" colorOnHover="gray" isDisabled={false}>
        <Button
          isDecorative
          isDisabled={false}
          icon={{ color: 'white', faIconDefinition: icon, size: 'lg' }}
          variant="ghost"
        />
        {showLabel && <span className="">{label}</span>}
      </Link>
    </Tooltip>
  );
}
